import React from 'react'

import { SectionContainer } from 'Components/Blocks'
import { Row } from 'Components/UI'
import { EventItem } from 'Types/emajinAPI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { Container } from './styles'

type Props = {
  event?: EventItem
}

function EventsHeroSection({ event }: Props) {
  if (!event || !event.attachments?.length || !event.attachments[0].url)
    return null

  return (
    <SectionContainer>
      <Row px={LANDING_CONTENT_PX}>
        <Container mt={[0, 0, 5]}>
          <img alt="" src={event.attachments[0].url} />
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default EventsHeroSection
